import { render, staticRenderFns } from "./marketing-chart.vue?vue&type=template&id=21303b10&scoped=true&"
import script from "./marketing-chart.vue?vue&type=script&lang=js&"
export * from "./marketing-chart.vue?vue&type=script&lang=js&"
import style0 from "./marketing-chart.vue?vue&type=style&index=0&id=21303b10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21303b10",
  null
  
)

export default component.exports